<template>
  <header class="site-header" :class="{ 'is-scrolled': isScrolled }">
    <nav class="site-nav" aria-label="Primary navigation">
      <router-link class="brand-link" to="/" @click.native="closeAll">
        <img src="@/assets/images/name_logo.png" alt="Fathom Ocean">
      </router-link>

      <button
        class="nav-toggle"
        type="button"
        :aria-expanded="String(isOpen)"
        aria-controls="primary-navigation"
        aria-label="Toggle navigation"
        @click="isOpen = !isOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div id="primary-navigation" class="nav-panel" :class="{ 'is-open': isOpen }">
        <ul class="nav-list">
          <li>
            <router-link class="nav-link" to="/" exact @click.native="closeAll">home</router-link>
          </li>
          <li>
            <router-link class="nav-link" to="/industry" @click.native="closeAll">applications</router-link>
          </li>
          <li
            class="nav-group"
            :class="{ 'is-open': openMenu === 'cameras' }"
            @mouseenter="openDesktopMenu('cameras')"
            @mouseleave="scheduleClose"
            @focusin="openDesktopMenu('cameras')"
            @focusout="handleGroupFocusOut"
          >
            <button
              class="nav-group-trigger"
              type="button"
              :aria-expanded="String(openMenu === 'cameras')"
              aria-controls="camera-navigation"
              aria-haspopup="true"
              @click="toggleMenu('cameras')"
              @keydown="handleTriggerKeydown($event, 'cameras')"
            >
              deployments
            </button>
            <div
              id="camera-navigation"
              class="nav-dropdown"
              @mouseenter="cancelClose"
              @mouseleave="scheduleClose"
              @keydown="handleDropdownKeydown($event, 'cameras')"
            >
              <router-link to="/live-cameras/coral-city" @click.native="closeAll">Coral City Camera</router-link>
              <router-link to="/live-cameras/wahoo-bay" @click.native="closeAll">Wahoo Bay</router-link>
              <router-link to="/live-cameras/okaloosa-island-pier" @click.native="closeAll">Okaloosa Island Pier</router-link>
              <router-link to="/live-cameras/mega-lab-hawaii-1" @click.native="closeAll">MEGA Lab Hawaii </router-link>
            </div>
          </li>
          <li
            class="nav-group"
            :class="{ 'is-open': openMenu === 'products' }"
            @mouseenter="openDesktopMenu('products')"
            @mouseleave="scheduleClose"
            @focusin="openDesktopMenu('products')"
            @focusout="handleGroupFocusOut"
          >
            <button
              class="nav-group-trigger"
              type="button"
              :aria-expanded="String(openMenu === 'products')"
              aria-controls="product-navigation"
              aria-haspopup="true"
              @click="toggleMenu('products')"
              @keydown="handleTriggerKeydown($event, 'products')"
            >
              products
            </button>
            <div
              id="product-navigation"
              class="nav-dropdown"
              @mouseenter="cancelClose"
              @mouseleave="scheduleClose"
              @keydown="handleDropdownKeydown($event, 'products')"
            >
              <router-link to="/products/Angler" @click.native="closeAll">Angler™</router-link>
              <router-link to="/products/octopus" @click.native="closeAll">Octopus™</router-link>
              <router-link to="/products/periscope" @click.native="closeAll">Periscope AI™</router-link>
              <router-link to="/products/comparesystems" @click.native="closeAll">Compare Systems</router-link>
            </div>
          </li>
          <li>
            <router-link class="nav-link" to="/resources" @click.native="closeAll">resources</router-link>
          </li>
          <li>
            <router-link class="nav-link" to="/about" @click.native="closeAll">about</router-link>
          </li>
          <li>
            <router-link class="button nav-cta" to="/contact" @click.native="closeAll">Request a Consultation</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isOpen: false,
      openMenu: null,
      closeTimer: null,
      suppressFocusOpen: false,
      isScrolled: false,
    }
  },
  watch: {
    $route() {
      this.closeAll()
    },
  },
  beforeDestroy() {
    this.cancelClose()
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleGlobalKeydown)
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    window.addEventListener('keydown', this.handleGlobalKeydown)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 24
    },
    handleGlobalKeydown(event) {
      if (event.key !== 'Escape' || !this.isOpen) return
      event.preventDefault()
      this.closeAll()
      this.$nextTick(() => {
        const toggle = this.$el.querySelector('.nav-toggle')
        if (toggle) toggle.focus()
      })
    },
    usesDesktopNavigation() {
      return window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)').matches
    },
    cancelClose() {
      if (this.closeTimer) {
        window.clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    openDesktopMenu(menu) {
      if (!this.usesDesktopNavigation() || this.suppressFocusOpen) return
      this.cancelClose()
      this.openMenu = menu
    },
    scheduleClose() {
      if (!this.usesDesktopNavigation()) return
      this.cancelClose()
      this.closeTimer = window.setTimeout(() => {
        this.openMenu = null
        this.closeTimer = null
      }, 260)
    },
    handleGroupFocusOut(event) {
      if (event.currentTarget.contains(event.relatedTarget)) return
      if (this.usesDesktopNavigation()) this.scheduleClose()
      else this.openMenu = null
    },
    toggleMenu(menu) {
      this.cancelClose()
      this.openMenu = this.openMenu === menu ? null : menu
    },
    focusDropdownItem(menu, position = 0) {
      this.openMenu = menu
      this.$nextTick(() => {
        const dropdown = document.getElementById(`${menu === 'cameras' ? 'camera' : 'product'}-navigation`)
        const links = dropdown ? Array.from(dropdown.querySelectorAll('a')) : []
        if (links.length) links[Math.max(0, Math.min(position, links.length - 1))].focus()
      })
    },
    handleTriggerKeydown(event, menu) {
      if (event.key === 'ArrowDown') {
        event.preventDefault()
        this.focusDropdownItem(menu, 0)
      } else if (event.key === 'ArrowUp') {
        event.preventDefault()
        this.focusDropdownItem(menu, Number.MAX_SAFE_INTEGER)
      } else if (event.key === 'Escape') {
        event.preventDefault()
        this.openMenu = null
      }
    },
    handleDropdownKeydown(event, menu) {
      const links = Array.from(event.currentTarget.querySelectorAll('a'))
      const index = links.indexOf(document.activeElement)
      let nextIndex = index

      if (event.key === 'ArrowDown') nextIndex = index < links.length - 1 ? index + 1 : 0
      else if (event.key === 'ArrowUp') nextIndex = index > 0 ? index - 1 : links.length - 1
      else if (event.key === 'Home') nextIndex = 0
      else if (event.key === 'End') nextIndex = links.length - 1
      else if (event.key === 'Escape') {
        event.preventDefault()
        this.openMenu = null
        const trigger = event.currentTarget.previousElementSibling
        if (trigger) {
          this.suppressFocusOpen = true
          trigger.focus()
          this.$nextTick(() => {
            this.suppressFocusOpen = false
          })
        }
        return
      } else return

      event.preventDefault()
      if (links[nextIndex]) links[nextIndex].focus()
    },
    closeAll() {
      this.cancelClose()
      this.isOpen = false
      this.openMenu = null
    },
  },
}
</script>
